import { render, staticRenderFns } from "./video.vue?vue&type=template&id=312a8bad&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312a8bad')) {
      api.createRecord('312a8bad', component.options)
    } else {
      api.reload('312a8bad', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=312a8bad&", function () {
      api.rerender('312a8bad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "组件/Admin/src/router/views/ui/video.vue"
export default component.exports